/**
 * 创建人：袁俊双
 * 时间：2019-11-11
 * 描述：用于解决防止用户连续点击保存按钮,导致多次请求的问题
 * 更新记录: 
 * 使用说明: 
 *  <botton  SwDebounceClick (debounceClick)="save()">点击</botton>
 *  debounceTime 有默认值 300毫秒, 如果想指定时间间隔,就自己设置
 *  <botton  SwDebounceClick (debounceClick)="save()" [debounceTime]="700">点击</botton>
 */
import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[SwDebounceClick]'
})
export class SwDebounceClickDirective {
  @Input() debounceTime = 300;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;
  constructor() { }
  ngOnInit() { 
    this.subscription = this.clicks.pipe(
      debounceTime(this.debounceTime)
    ).subscribe(e => this.debounceClick.emit(e));

  }

  ngOnDestroy() {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
